import styled, { css } from 'styled-components'
import { mediaQueries } from '../../../providers/MediaQueryProvider'
import { HELPER_CLASS } from '../consts'

type WrapperProps = {
  isDragged?: boolean
}

export const Container = styled.div<{ $isLastSection: boolean }>`
  margin-left: var(--space-400);
  position: relative;

  &:before {
    content: '';
    height: 1px;
    width: var(--space-400);
    background-color: var(--border-secondary);
    position: absolute;
    left: var(--space-n400);
    top: 50%;
  }

  &:after {
    content: '';
    height: calc(100% + var(--space-300));
    width: 1px;
    background-color: var(--border-secondary);
    position: absolute;
    top: 0;
    left: var(--space-n400);
  }

  ${({ $isLastSection }) =>
    $isLastSection &&
    css`
      &:last-child:after {
        height: 50%;
      }
    `}
`

export const ToolbarWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: var(--space-300);
  transform: translateY(-50%);

  ${mediaQueries.tablet} {
    display: none;
    right: var(--space-500);
  }
`

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  background-color: var(--bg-secondary);
  padding: var(--space-300);
  margin-bottom: var(--space-300);

  ${({ isDragged }) =>
    !isDragged &&
    css`
      &:hover ${ToolbarWrapper} {
        display: block;
      }
    `}

  &.${HELPER_CLASS} {
    pointer-events: auto !important;
    z-index: 999;
  }

  &.${HELPER_CLASS} ${ToolbarWrapper} {
    display: block;
  }
`

export const Placeholder = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-tertiary);
`
